// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import { useAuth } from '../auth/context/AuthContext';

// const OTP_EXPIRY_TIME = 300; // 5 minutes (in seconds)

// const LoginCustomer = () => {
//   const [phoneNumber, setPhoneNumber] = useState('');
//   const [verificationCode, setVerificationCode] = useState('');
//   const [step, setStep] = useState('phone');
//   const [error, setError] = useState('');
//   const [otpTimer, setOtpTimer] = useState(OTP_EXPIRY_TIME);
//   const [otpInterval, setOtpInterval] = useState(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const { customerLogin, isCustomerAuthenticated } = useAuth();

//   const [isProcessingPhone, setIsProcessingPhone] = useState(false);
//   const [isProcessingVerification, setIsProcessingVerification] =
//     useState(false);
//   const [isProcessingResendOtp, setIsProcessingResendOtp] = useState(false);

//   useEffect(() => {
//     if (isCustomerAuthenticated) {
//       const { from } = location.state || { from: '/customer-dashboard' };
//       navigate(from, { replace: true });
//     }
//   }, [isCustomerAuthenticated, navigate, location]);

//   const handlePhoneSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     setIsProcessingPhone(true);
//     try {
//       await axios.post('/api/auth/customer/login', { phoneNumber });
//       setStep('verify');
//       startOtpTimer();
//     } catch (error) {
//       setError('Failed to send verification code. Please try again.');
//     } finally {
//       setIsProcessingPhone(false);
//     }
//   };

//   const startOtpTimer = () => {
//     if (otpInterval) clearInterval(otpInterval);
//     setOtpTimer(OTP_EXPIRY_TIME);
//     const interval = setInterval(() => {
//       setOtpTimer((prev) => {
//         if (prev === 1) clearInterval(interval);
//         return prev - 1;
//       });
//     }, 1000);
//     setOtpInterval(interval);
//   };

//   const handleResendOtp = async () => {
//     setError('');
//     setIsProcessingResendOtp(true);
//     try {
//       await axios.post('/api/auth/customer/login', { phoneNumber });
//       startOtpTimer();
//     } catch (error) {
//       setError('Failed to resend OTP. Please try again.');
//     } finally {
//       setIsProcessingResendOtp(false);
//     }
//   };

//   const handleVerificationSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     setIsProcessingVerification(true);
//     try {
//       const response = await axios.post('/api/auth/customer/verify-otp', {
//         phoneNumber,
//         verificationCode,
//       });
//       if (response.data.token) {
//         customerLogin(response.data.token);
//         const { from } = location.state || { from: '/customer-dashboard' };
//         navigate(from, { replace: true });
//       }
//     } catch (error) {
//       setError('Invalid verification code. Please try again.');
//     } finally {
//       setIsProcessingVerification(false);
//     }
//   };

//   const handleGoBack = () => {
//     setStep('phone');
//     setVerificationCode('');
//     clearInterval(otpInterval);
//     setOtpTimer(OTP_EXPIRY_TIME);
//   };

//   const renderStep = () => {
//     switch (step) {
//       case 'phone':
//         return (
//           <form onSubmit={handlePhoneSubmit} className='space-y-4'>
//             <div>
//               <label
//                 htmlFor='phoneNumber'
//                 className='block text-sm font-medium text-gray-700'
//               >
//                 Phone Number
//               </label>
//               <input
//                 type='tel'
//                 id='phoneNumber'
//                 value={phoneNumber}
//                 onChange={(e) => setPhoneNumber(e.target.value)}
//                 required
//                 className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
//                 placeholder='Enter your phone number'
//               />
//             </div>
//             {error && <p className='text-red-500 text-sm'>{error}</p>}
//             <button
//               type='submit'
//               className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
//               disabled={isProcessingPhone}
//             >
//               {isProcessingPhone ? 'Processing...' : 'Send Verification Code'}
//             </button>
//           </form>
//         );
//       case 'verify':
//         return (
//           <form onSubmit={handleVerificationSubmit} className='space-y-4'>
//             <div>
//               <label
//                 htmlFor='verificationCode'
//                 className='block text-sm font-medium text-gray-700'
//               >
//                 Verification Code
//               </label>
//               <input
//                 type='text'
//                 id='verificationCode'
//                 value={verificationCode}
//                 onChange={(e) => setVerificationCode(e.target.value)}
//                 required
//                 className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
//                 placeholder='Enter verification code'
//               />
//             </div>
//             {error && <p className='text-red-500 text-sm'>{error}</p>}
//             <button
//               type='submit'
//               className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
//               disabled={isProcessingVerification}
//             >
//               {isProcessingVerification ? 'Processing...' : 'Verify and Login'}
//             </button>
//             <button
//               onClick={handleGoBack}
//               className='w-full mt-2 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-500 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400'
//             >
//               Go Back
//             </button>
//             <button
//               onClick={handleResendOtp}
//               className='w-full mt-2 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-500 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-400'
//               disabled={isProcessingResendOtp}
//             >
//               {isProcessingResendOtp ? 'Processing...' : 'Resend OTP'}
//             </button>
//             <p>OTP expires in {otpTimer} seconds</p>
//           </form>
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className='max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-xl'>
//       <h1 className='text-2xl font-bold mb-4 text-center'>Customer Login</h1>
//       {renderStep()}
//     </div>
//   );
// };

// export default LoginCustomer;
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../auth/context/AuthContext';
import api from '../../services/api';
const OTP_EXPIRY_TIME = 300;

const LoginCustomer = () => {
  const [loginMethod, setLoginMethod] = useState('phone');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [signupEmail, setSignupEmail] = useState('');
  const [signupPassword, setSignupPassword] = useState('');
  const [step, setStep] = useState('phone');
  const [error, setError] = useState('');
  const [otpTimer, setOtpTimer] = useState(OTP_EXPIRY_TIME);
  const [otpInterval, setOtpInterval] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const { customerLogin, isCustomerAuthenticated } = useAuth();

  const [isProcessingPhone, setIsProcessingPhone] = useState(false);
  const [isProcessingVerification, setIsProcessingVerification] =
    useState(false);
  const [isProcessingResendOtp, setIsProcessingResendOtp] = useState(false);
  const [isProcessingEmail, setIsProcessingEmail] = useState(false);
  const [isProcessingSignup, setIsProcessingSignup] = useState(false);

  useEffect(() => {
    if (isCustomerAuthenticated) {
      navigate(location.state?.from || '/subscripitons');
    }
  }, [isCustomerAuthenticated, navigate, location]);

  const handlePhoneSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsProcessingPhone(true);
    try {
      await api.post('/auth/customer/login', { phoneNumber });
      setStep('verify');
      startOtpTimer();
    } catch (error) {
      setError('Failed to send verification code');
    } finally {
      setIsProcessingPhone(false);
    }
  };

  const startOtpTimer = () => {
    if (otpInterval) clearInterval(otpInterval);
    setOtpTimer(OTP_EXPIRY_TIME);
    const interval = setInterval(() => {
      setOtpTimer((prev) => {
        if (prev === 1) clearInterval(interval);
        return prev - 1;
      });
    }, 1000);
    setOtpInterval(interval);
  };

  const handleResendOtp = async () => {
    setError('');
    setIsProcessingResendOtp(true);
    try {
      await api.post('/auth/customer/login', { phoneNumber });
      startOtpTimer();
    } catch (error) {
      setError('Failed to resend OTP. Please try again.');
    } finally {
      setIsProcessingResendOtp(false);
    }
  };

  const handleVerificationSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsProcessingVerification(true);
    try {
      const response = await api.post('/auth/customer/verify-otp', {
        phoneNumber,
        verificationCode,
      });

      if (response.data.requiresSignup) {
        setStep('signup');
      } else {
        customerLogin(response.data.token);
        navigate(location.state?.from || '/subscriptions');
      }
    } catch (error) {
      setError('Invalid verification code');
    } finally {
      setIsProcessingVerification(false);
    }
  };

  const handleSignupSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsProcessingSignup(true);
    try {
      const response = await api.post('/auth/customer/verify-and-signup', {
        phoneNumber,
        email: signupEmail,
        password: signupPassword,
      });
      customerLogin(response.data.token);
      navigate(location.state?.from || '/subscriptions');
    } catch (error) {
      setError(error.response?.data?.message || 'Signup failed');
    } finally {
      setIsProcessingSignup(false);
    }
  };

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsProcessingEmail(true);
    try {
      const response = await api.post('/customers/login/email', {
        email,
        password,
      });
      if (response.data.token) {
        customerLogin(response.data.token);
        navigate(location.state?.from || '/customer-dashboard');
      }
    } catch (error) {
      setError('Invalid email or password');
    } finally {
      setIsProcessingEmail(false);
    }
  };

  const handleGoBack = () => {
    setStep('phone');
    setVerificationCode('');
    clearInterval(otpInterval);
    setOtpTimer(OTP_EXPIRY_TIME);
  };

  const renderTabs = () => (
    <div className='flex mb-4 border-b'>
      <button
        className={`px-4 py-2 ${
          loginMethod === 'phone'
            ? 'border-b-2 border-indigo-500 text-indigo-600'
            : 'text-gray-500'
        }`}
        onClick={() => {
          setLoginMethod('phone');
          setError('');
        }}
      >
        Phone Login
      </button>
      <button
        className={`px-4 py-2 ${
          loginMethod === 'email'
            ? 'border-b-2 border-indigo-500 text-indigo-600'
            : 'text-gray-500'
        }`}
        onClick={() => {
          setLoginMethod('email');
          setError('');
        }}
      >
        Email Login
      </button>
    </div>
  );

  const renderStep = () => {
    switch (step) {
      case 'phone':
        return (
          <form onSubmit={handlePhoneSubmit} className='space-y-4'>
            <div>
              <label
                htmlFor='phoneNumber'
                className='block text-sm font-medium text-gray-700'
              >
                Phone Number
              </label>
              <input
                type='tel'
                id='phoneNumber'
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
                className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
                placeholder='Enter your phone number'
              />
            </div>
            {error && <p className='text-red-500 text-sm'>{error}</p>}
            <button
              type='submit'
              className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
              disabled={isProcessingPhone}
            >
              {isProcessingPhone ? 'Processing...' : 'Send Verification Code'}
            </button>
          </form>
        );
      case 'verify':
        return (
          <form onSubmit={handleVerificationSubmit} className='space-y-4'>
            <div>
              <label
                htmlFor='verificationCode'
                className='block text-sm font-medium text-gray-700'
              >
                Verification Code
              </label>
              <input
                type='text'
                id='verificationCode'
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                required
                className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
                placeholder='Enter verification code'
              />
            </div>
            {error && <p className='text-red-500 text-sm'>{error}</p>}
            <button
              type='submit'
              className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
              disabled={isProcessingVerification}
            >
              {isProcessingVerification ? 'Processing...' : 'Verify Code'}
            </button>
            <button
              onClick={handleGoBack}
              className='w-full mt-2 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-500 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400'
            >
              Go Back
            </button>
            <button
              onClick={handleResendOtp}
              className='w-full mt-2 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-500 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-400'
              disabled={isProcessingResendOtp}
            >
              {isProcessingResendOtp ? 'Processing...' : 'Resend OTP'}
            </button>
            <p>OTP expires in {otpTimer} seconds</p>
          </form>
        );
      case 'signup':
        return (
          <form onSubmit={handleSignupSubmit} className='space-y-4'>
            <div>
              <label
                htmlFor='signupEmail'
                className='block text-sm font-medium text-gray-700'
              >
                Email
              </label>
              <input
                type='email'
                id='signupEmail'
                value={signupEmail}
                onChange={(e) => setSignupEmail(e.target.value)}
                required
                className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
                placeholder='Enter your email'
              />
            </div>
            <div>
              <label
                htmlFor='signupPassword'
                className='block text-sm font-medium text-gray-700'
              >
                Password
              </label>
              <input
                type='password'
                id='signupPassword'
                value={signupPassword}
                onChange={(e) => setSignupPassword(e.target.value)}
                required
                className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
                placeholder='Choose a password'
              />
            </div>
            {error && <p className='text-red-500 text-sm'>{error}</p>}
            <button
              type='submit'
              className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
              disabled={isProcessingSignup}
            >
              {isProcessingSignup ? 'Processing...' : 'Complete Signup'}
            </button>
          </form>
        );
      default:
        return null;
    }
  };

  const renderEmailLogin = () => (
    <form onSubmit={handleEmailLogin} className='space-y-4'>
      <div>
        <label
          htmlFor='email'
          className='block text-sm font-medium text-gray-700'
        >
          Email
        </label>
        <input
          type='email'
          id='email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
          placeholder='Enter your email'
        />
      </div>
      <div>
        <label
          htmlFor='password'
          className='block text-sm font-medium text-gray-700'
        >
          Password
        </label>
        <input
          type='password'
          id='password'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className='mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
          placeholder='Enter your password'
        />
      </div>
      {error && <p className='text-red-500 text-sm'>{error}</p>}
      <button
        type='submit'
        className='w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
        disabled={isProcessingEmail}
      >
        {isProcessingEmail ? 'Processing...' : 'Login'}
      </button>
    </form>
  );

  const renderContent = () => {
    if (loginMethod === 'email') {
      return renderEmailLogin();
    }
    return renderStep();
  };

  return (
    <div className='max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-xl'>
      <h1 className='text-2xl font-bold mb-4 text-center'>Customer Login</h1>
      {renderTabs()}
      {renderContent()}
    </div>
  );
};

export default LoginCustomer;
